<template>
  <div class="panel-wrapper" :style="!isQianKun? `height: ${canvasHeight}px; width: ${canvasWidth}px;position: relative;` : ''" v-if="elements">
    <div class="editor-modal" v-if="isLoadingRealScene"></div>
    <div class="process-text" v-if="isLoadingRealScene">{{sceneText}}</div>
    <!-- <Caterpillars v-if="isLoadingRealScene"></Caterpillars> -->
    <!-- <DummyElement v-for="element in elements" :key="element._key" :element="element"></DummyElement> -->
    <div :key="pageIndex">
      <div v-for="(item, index) in elements" :key="item.id" style="position: absolute;">
        <ElementBox
          :type="item.type" :ref="item.id" :element="item" :index="index"
          v-if="item.type !== 'group' && (!item.isHidden || item.isHidden == null)"
        >
        </ElementBox>
        <GroupBox
          :type="item.type" :group="item" :id="item.id" :index="index"
          v-else-if="!item.isHidden || item.isHidden == null"
        >
        </GroupBox>
      </div>
    </div>
    <PreScene
      v-if="showPreSceneElement && isLoadSceneDefault && !isQianKun"
      :preSceneElement="preSceneElement"
      :sceneOption="sceneOption"
      style="width: 100%; height: 100%"
    />
    <div v-if="!isQianKun" :style="`visibility: ${showPreSceneElement ? 'hidden' : ''}`" class="render-wrapper">
      <div id="player" :style="`height: ${canvasHeight}px; width: ${canvasWidth}px;`"></div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import event from '@/util/event'
import Caterpillars from '@/components/Caterpillars'
import DummyElement from '@/editorComponents/DummyElement'
import PreScene from '@/editorComponents/PreScene/index'
import { renderCloudLogin, renderCloudUrl } from './data'
import AES from '@/util/AES.js';
import { tipList } from '@/util/sceneTip'
import appConst from '@/util/editorConst'
import {
  Message,
  LoadingBar
} from 'view-design'
import { getUrlParams } from '@/util/editor/tools'
const PANEL_DATA = window.PANEL_DATA || null
// 场景实例
let sceneRender = null

export default {
  name: 'panelWrapper',
  components: {
    DummyElement,
    PreScene,
    Caterpillars
  },
  data () {
    return {
      sceneText: '场景连接中...',
      isQianKun: window.__POWERED_BY_QIANKUN__,
      sceneRender: null,
      panel: null, // 面板数据
      pages: null,
      sceneOption: null,
      canvasHeight: null,
      canvasWidth: null,
      dynamicServer: null,
      projectId: null,
      preSceneElement: null,
      apiVersion: null,
      cloudParams: null,
      isLoadingRealScene: false,
      setCameraInfoData: null,
      isLoadSceneDefault: true
    }
  },
  mounted () {
    LoadingBar && LoadingBar.config({
      color: '#fff',
      height: 8
    })
    this.cloudParams = getUrlParams()
    if (!PANEL_DATA) {
      console.log('缺少面板数据-------')
      return
    }
    this.panel = PANEL_DATA
    console.log(PANEL_DATA, '// PANEL_DATA initPage')
    const currentPageIndex = (this.cloudParams && this.cloudParams.position === 'current' && this.cloudParams.pageId && this.panel.pages.findIndex(val => val.id === this.cloudParams.pageId)) || 0
    this.$EventBus.pageIndex = currentPageIndex
    this.$nextTick(() => {
      this.initPage()
      // 判断是否加载场景
      if ((this.cloudParams && this.cloudParams.isLoadScene !== 'false') || !this.cloudParams) {
        this.initSceneOption()
      }
      if (this.cloudParams && Object.keys(this.cloudParams).length) {
        this.$blueMap && this.$blueMap.trigger({
          nodeType: 'params-init',
          pluginId: '',
          dataKey: 'params-collect',
          eventData: {
            value: this.cloudParams,
            data: null,
            event: null
          }
        })
      }
      // 添加全局键盘按键事件
      document.addEventListener('keydown', this.keydownEvent)
      document.addEventListener('keyup', this.keyupEvent)
    })
  },
  watch: {
    pageIndex: {
      handler(val){
        this.initPage()
      }
    }
  },
  computed: {
    elements () {
      if (!this.panel || !this.panel.pages) return []
      return (this.panel.pages && this.panel.pages[this.$EventBus.pageIndex] && this.panel.pages[this.$EventBus.pageIndex].elements && (this.panel.pages[this.$EventBus.pageIndex].elements.filter(it => it.type !== 'bg'))) || []
    },
    page() {
      if (!this.panel || !this.panel.pages) return []
      return (this.panel.pages && this.panel.pages[this.$EventBus.pageIndex])
    },
    pageIndex() {
      return this.$EventBus.pageIndex
    },
    showPreSceneElement () {
      // sceneOption 场景配置
      // loadRealScene 读取真实场景
      // renderIsReady 真实场景初始化成功
      // this.preSceneElement 预加载场景
      // isCsScene cs端场景
      let showPreSceneElement = false
      const { sceneOption, renderIsReady } = this.$EventBus || null
      let isCsScene = null
      let loadRealScene = null
      if (sceneOption) {
        isCsScene = sceneOption.isCsScene
        loadRealScene = sceneOption.loadRealScene
      }
      console.group('showPreSceneElement-------')
      console.table({ ...sceneOption, renderIsReady })
      console.groupEnd()
      if (isCsScene) {
        showPreSceneElement = false
      }
      // 加载真实场景 且 场景初始化成功
      if (loadRealScene && renderIsReady) {
        showPreSceneElement = false
      }
      if (this.preSceneElement && !renderIsReady) {
        showPreSceneElement = true
      }
      return showPreSceneElement
    }
  },
  methods: {
    initPage () {
      const global = this.$EventBus
      const {
        canvasHeight,
        canvasWidth,
        dynamicServer,
        apiVersion,
        projectId,
        sceneOption,
        panelFilters
      } = PANEL_DATA || null
      global.viewportList = this.panel.pages[global.pageIndex]
      this.canvasHeight = this.page.windowFlag && this.page.windowFlag * 1 === 1 ? (this.page.option && this.page.option.boxHeight) || 0 : global.canvasHeight = canvasHeight
      this.canvasWidth = this.page.windowFlag && this.page.windowFlag * 1 === 1 ? (this.page.option && this.page.option.boxWidth) || 0 : global.canvasWidth = canvasWidth
      this.dynamicServer = global.dynamicServer = dynamicServer
      this.apiVersion = global.apiVersion = apiVersion
      this.projectId = global.projectId = projectId
      this.sceneOption = global.sceneOption = sceneOption
      this.panelFilters = global.panelFilters = panelFilters
      if (this.page.windowFlag && this.page.windowFlag * 1 === 1) {
        this.isLoadSceneDefault = false
      }
      // 前置场景 图片、视频
      this.preSceneElement = sceneOption
      this.$blueMap.setVueInstance(this)
      // update eventbus
      // this.$EventBus.renderIsReady = false
    },
    // 初始化场景配置
    initSceneOption () {
      console.log(this.sceneOption, '// sceneOption in initSceneOption~~~~~~~~~~~')
      // 加载真实场景
      if (!this.sceneOption || lodash.isEmpty(this.sceneOption)) {
        return
      }
      this.$EventBus.sceneOption = this.sceneOption
      if (this.sceneOption.isCsScene) {
        // 客户端渲染
        this.isLoadingRealScene = false
        this.handleRenderClient()
      } else {
        // 云渲染
        this.sceneOption.loadRealScene && !window.__POWERED_BY_QIANKUN__ && this.handleRenderCloud()
      }
    },
    // 客户端渲染
    async handleRenderClient() {
      if (this.sceneRender || !this.apiVersion) return
      console.group('smartAPI init')
      console.log(this.apiVersion, '// super apiVersion')
      const { csOption, csOption: { source, _url } } = this.$EventBus.sceneOption || null
      if (!csOption || !source || !_url) return
      let SmartAPI = null
      switch (this.apiVersion) {
        case '3.3.0':
          SmartAPI = await import(/* webpackChunkName: "SmartAPI-3.3.0" */ '../util/smartAPI/SmartAPI-3.3.0.js')
          console.log('SmartAPI 3.3.0')
          break
        case '3.2.0':
          SmartAPI = await import(/* webpackChunkName: "SmartAPI-3.2.0" */ '../util/smartAPI/SmartAPI-3.2.0.js')
          console.log('SmartAPI 3.2.0')
          break
        case '3.1.0':
          SmartAPI = await import(/* webpackChunkName: "SmartAPI-3.1.0" */ '../util/smartAPI/SmartAPI-3.1.0.js')
          console.log('SmartAPI 3.1.0')
          break
        case '3.0.0':
          SmartAPI = await import(/* webpackChunkName: "SmartAPI-3.0.0" */ '../util/smartAPI/SmartAPI-3.0.0.js')
          console.log('SmartAPI 3.0.0')
          break
        case '2.8.0':
          SmartAPI = await import(/* webpackChunkName: "SmartAPI-2.8.0" */ '../util/smartAPI/SmartAPI-2.8.0.js')
          console.log('SmartAPI 2.8.0')
          break
        default :
          SmartAPI = await import(/* webpackChunkName: "SmartAPI-3.3.0" */ '../util/smartAPI/SmartAPI-3.3.0.js')
          console.log('default SmartAPI 3.3.0')
          break
      }
      console.groupEnd();
      const Render = SmartAPI.default
      sceneRender = this.sceneRender = new Render(_url, source);
      // update eventbus
      this.$EventBus.sceneRender = sceneRender
      this.$EventBus.renderIsReady = true
      // cs端事件监听
      event.on('sendToPage', this.registerSmartApiResponse)
      window.registerSmartApiResponse = event
    },
    // 处理cs端监听回调业务
    registerSmartApiResponse(data) {
      console.log(data, '// registerSmartApiResponse data ---------')
    },
    // 云渲染
    async handleRenderCloud() {
      if (this.sceneRender || !this.apiVersion) {
        Message.error('场景配置信息缺少api版本号');
        this.isLoadingRealScene = false
        return
      }
      console.log(this.apiVersion, '// super apiVersion')
      let CloudRenderer = null
      // this.apiVersion = '6.2.0'
      // await import(/* webpackChunkName: "OpenAPI" */ '../util/superAPI/OpenAPI.js')
      switch (this.apiVersion) {
        case '6.2.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-6.2.0" */ '../util/superAPI/superAPI-6.2.0.js')
          break
        case '6.1.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-6.1.0" */ '../util/superAPI/superAPI-6.1.0.js')
          break
        case '6.0.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-6.0.0" */ '../util/superAPI/superAPI-6.0.0.js')
          break
        case '5.4.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-5.4.0" */ '../util/superAPI/superAPI-5.4.0.js')
          break
        case '5.3.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-5.3.0" */ '../util/superAPI/superAPI-5.3.0.js')
          break
        case '5.2.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-5.2.0" */ '../util/superAPI/superAPI-5.2.0.js')
          break
        case '5.1.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-5.1.0" */ '../util/superAPI/superAPI-5.1.0.js')
          break
        case '5.0.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-5.0.0" */ '../util/superAPI/superAPI-5.0.0.js')
          break
        case '4.1.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-4.1.0" */ '../util/superAPI/superAPI-4.1.0.js')
          break
        case '4.0.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-4.0.0" */ '../util/superAPI/superAPI-4.0.0.js')
          break
        case '3.3.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-3.3.0" */ '../util/superAPI/superAPI-3.3.0.js')
          break
        case '3.2.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-3.2.0" */ '../util/superAPI/superAPI-3.2.0.js')
          break
        case '3.1.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-3.1.0" */ '../util/superAPI/superAPI-3.1.0.js')
          break
        case '3.0.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-3.0.0" */ '../util/superAPI/superAPI-3.0.0.js')
          break
        case '2.8.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-2.8.0" */ '../util/superAPI/superAPI-2.8.0.js')
          break
        case '2.7.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-2.7.0" */ '../util/superAPI/superAPI-2.7.0.js')
          break
        case '2.6.0':
          CloudRenderer = await import(/* webpackChunkName: "superAPI-2.6.0" */ '../util/superAPI/superAPI-2.6.0.js')
          break
        default :
          CloudRenderer = await import(/* webpackChunkName: "superAPI-6.2.0" */ '../util/superAPI/superAPI-6.2.0.js')
          break
      }

      const Render = CloudRenderer.default || null
      // sceneRender = this.sceneRender = new Render('player', 0)
      const isOldVersion = this.apiVersion === '2.6.0' || this.apiVersion === '2.7.0' || this.apiVersion === '2.8.0' || this.apiVersion === '3.0.0' || this.apiVersion === '3.1.0' || this.apiVersion === '3.2.0'
      sceneRender = this.sceneRender = isOldVersion ? new Render('player', 0) : new Render('player', 0, 'noStyle')
      let { _url, renderPath, UserName, Password, order, keyboard } = this.sceneOption || null
      // 去掉最后的斜杠
      if (this.cloudParams && this.cloudParams.serve && this.cloudParams.order) {
        _url = this.cloudParams.serve
        order = this.cloudParams.order || ''
      }
      if ((!_url || !renderPath || !UserName || !Password) && (!order || !_url)) {
        Message.warning('请检查场景配置信息或是否已下载案例场景');
        this.isLoadingRealScene = false
        return false
      }
      const renderPathPrepend = order ? 'Renderers/Any/order' : 'Renderers/Any/'
      let res = null
      _url = (_url[_url.length - 1] === '/' ? _url : _url + '/').trim()
      if (!order) {
        const params = {
          username: AES.decrypt(UserName, appConst.AES_KEY) || UserName,
          pwd: AES.decrypt(Password, appConst.AES_KEY) || Password
        }
        const loginData = await renderCloudLogin(_url + 'autoLogin', {
          ...params
        }).catch(() => {
          Message.warning('获取场景token报错');
          this.isLoadingRealScene = false
        })
        // 渲染路径统一前缀
        if (!loginData || !loginData.token) {
          Message.warning('获取场景token报错');
          this.isLoadingRealScene = false
          return
        }
        res = await renderCloudUrl(`${_url}${renderPathPrepend + renderPath}`, {
          width: this.canvasWidth,
          height: this.canvasHeight
        }, {
          withCredentials: false,
          headers: {
            Authorization: `Bearer ${loginData.token}`
          }
        }).catch((e) => {
          Message.warning({
            content: e.message || tipList[res.errCode] || '云渲染资源获取异常',
            duration: 5
          });
          this.isLoadingRealScene = false
        })
      } else {
        res = await renderCloudUrl(`${_url}${renderPathPrepend}`, {
          width: this.canvasWidth,
          height: this.canvasHeight,
          order: order
        }, {
          withCredentials: false
        }).catch((e) => {
          Message.warning({
            content: e.message || tipList[res.errCode] || '云渲染资源获取异常',
            duration: 5
          });
          this.isLoadingRealScene = false
        })
      }
      if (!res || !res.url) {
        Message.warning({
          content: res.message || tipList[res.errCode] || '云渲染资源获取异常',
          duration: 5
        });
        this.isLoadingRealScene = false
        return
      }
      // res.mapPin = {
      //   coord_type: 0,
      //   cad_mapkey: '',
      //   latitude: 23.13207074,
      //   longitude: 113.34437899,
      //   arm_distance: 1000,
      //   pitch: 10,
      //   yaw: 0,
      //   fly: false
      // }
      if (res.mapPin) {
        this.setCameraInfoData = {
          coord_type: 0,
          cad_mapkey: '',
          center_coord: `${res.mapPin.longitude},${res.mapPin.latitude}`,
          arm_distance: 1000,
          pitch: 10,
          yaw: 0,
          fly: false
        }
      }
      // 事件注册
      sceneRender && sceneRender.SuperAPI('RegisterCloudResponse', this.myHandleResponseFunction);

      // 启动云渲染

      this.isLoadingRealScene = true
      LoadingBar.start();
      if (keyboard) {
        sceneRender && sceneRender.SuperAPI('StartRenderCloud', res.url, 'keyboardnofn');
      } else {
        sceneRender && sceneRender.SuperAPI('StartRenderCloud', res.url);
      }
      sceneRender.SuperAPI_onRenderCloudError = this.SuperAPI_onRenderCloudError
      sceneRender.SuperAPI_onUnavailableRender = this.SuperAPI_onUnavailableRender
      sceneRender.SuperAPI_onStopedRenderCloud = this.SuperAPI_onStopedRenderCloud
      sceneRender.SuperAPI_onRenderCloudConnected = this.SuperAPI_onRenderCloudConnected

      // update eventbus
      this.$EventBus.sceneRender = sceneRender
    },
    // 云渲染监听事件
    myHandleResponseFunction(data) {
      const jsonObject = JSON.parse(data);
      switch (jsonObject.func_name) {
        case 'beginPlay':
          console.group('beginPlay: 云渲染连接成功')
          console.log(this.$EventBus)
          console.log(sceneRender)
          console.groupEnd();
          break;
        case 'APIAlready':
          this.sceneText = '场景连接成功'
          LoadingBar.finish();
          this.$EventBus.renderIsReady = true
          console.group('APIAlready: 3D世界加载完成');
          console.log(sceneRender)
          console.log(this.$EventBus)
          console.groupEnd();
          setTimeout(() => {
            this.isLoadingRealScene = false
          }, 800)
          if (this.setCameraInfoData) {
            console.log(this.setCameraInfoData, '设置默认镜头数据');
            sceneRender.SuperAPI('SetCameraInfo', this.setCameraInfoData, (e) => {
              console.log(e, '默认镜头设置');
            })
          }
          this.$blueMap && this.$blueMap.trigger({
            nodeType: 'listen-all',
            pluginId: '',
            dataKey: 'listen',
            eventData: {
              value: 'APIAlready',
              data: null,
              event: null
            }
          })
          break;
        default:
          jsonObject && jsonObject.args && jsonObject.args.id && this.$blueMap && this.$blueMap.trigger({
            nodeType: 'listen-all',
            pluginId: '',
            dataKey: 'listen',
            eventData: {
              value: jsonObject,
              data: null,
              event: null
            }
          })
          break
      }
      return data
    },
    // 云渲染监听事件
    superAPI_onRenderCloudError(val) {
      this.sceneText = '场景连接中断'
      LoadingBar.error();
      setTimeout(() => {
        this.isLoadingRealScene = false
      }, 800)
      Message.error('场景加载出现异常');
      console.group('云渲染异常时的处理')
      console.log(val)
      console.log('云渲染异常时的处理...');
      console.groupEnd();
    },
    // 云渲染监听事件
    SuperAPI_onUnavailableRender(val) {
      this.sceneText = '场景连接中断'
      LoadingBar.error();
      setTimeout(() => {
        this.isLoadingRealScene = false
      }, 800)
      Message.error('云渲染关闭或通信息中断');
      console.group('云渲染关闭或通信息中断')
      console.log(val)
      console.log('云渲染关闭或通信息中断 业务逻辑...');
      console.groupEnd();
    },
    // 云渲染监听事件
    SuperAPI_onStopedRenderCloud(val) {
      this.sceneText = '场景连接中断'
      LoadingBar.error();
      setTimeout(() => {
        this.isLoadingRealScene = false
      }, 800)
      console.group('云渲染关闭或通信息中断')
      console.log(val)
      console.log('云渲染关闭或通信息中断 业务逻辑...');
      console.groupEnd();
    },
    // 云渲染监听事件
    SuperAPI_onRenderCloudConnected(val) {
      console.group('云服务连接成功')
      console.log(val)
      console.log('云服务连接成功 业务逻辑...');
      console.groupEnd();
    },
    // 绑定全局键盘事件
    keydownEvent: function (e) {
      this.$blueMap.trigger({
        nodeId: null,
        nodeType: 'keyboard-events',
        dataKey: 'onkeydown',
        eventData: e
      })
    },
    keyupEvent: function (e) {
      this.$blueMap.trigger({
        nodeId: null,
        nodeType: 'keyboard-events',
        dataKey: 'onkeyup',
        eventData: e
      })
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.keydownEvent)
    document.removeEventListener('keydown', this.keyupEvent)
  },
  destroyed () {
    // 卸载事件总线
    this.$EventBus.$off('update')
    this.$EventBus.$off('handleEleClick')
  }
}
</script>

<style lang="less" scoped>
  .editor-modal{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2007;
    background-color: #000;
    opacity: 0.3;
  }
  .process-text{
    font-size: 26px;
    position: fixed;
    top: calc(50vh - 50px);
    z-index: 2008;
    left: 50%;
    color: #fff;
    font-family: [SourceHanSansCN];
    transform: translate(-50%);
  }
.panel-wrapper {
  // position: relative;
  overflow: hidden;
}
.render-wrapper {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
}
</style>

<style>
.ivu-loading-bar {
    width: 30%;
    position: fixed;
    top: 50%;
    left: 50%;
    right: 0;
    z-index: 2008;
    transform: translate(-50%);
    background: #525252;
    border-radius: 10px;
}
.ivu-loading-bar-inner {
    transition: width .2s linear;
    border-radius: 10px;
    }
#player,
#streamingVideo,
#videoPlayOverlay {
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  /* right: 0 !important;
  bottom: 0 !important; */
  position: relative !important;
  background: none !important;
}
</style>
